import { Component, Inject, OnInit } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent {
  constructor(
    private matsnackbarRef: MatSnackBarRef<SnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  /**
   * @description get the relevant icon name
   * @retrun icon name of current snackbar
   */
  get getIcon(): { type: string; icon: string } | undefined {
    switch (this.data.snackType) {
      case 'success':
        return { type: this.data.snackType, icon: 'check_circle_outline' };
      case 'error':
        return { type: this.data.snackType, icon: 'error_outline' };
      case 'warn':
        return { type: this.data.snackType, icon: 'warning' };
      case 'info':
        return { type: this.data.snackType, icon: 'info' };
    }
  }
  /**
   * @description this function depend on close functionality
   * @returns executed and return any value
   */
  closeSnackbar(): void {
    this.matsnackbarRef.dismiss();
  }
}
